import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Trophy, Star } from 'lucide-react';
import { Section } from './Shared';
export const Pricing = () => {
  return <Section id="pricing" className="bg-brand-surfaceLight/60 rounded-3xl my-12 border border-brand-pink/20" data-id="element-302">
      <div className="text-center mb-10" data-id="element-303">
        <h2 className="text-2xl md:text-4xl font-display font-bold text-brand-pinkDark" data-id="element-304">
          Empezá hoy tu camino de sanación
        </h2>
        <p className="text-brand-text/70 mt-3 text-sm md:text-base" data-id="element-305">
          ⏰ El precio de lanzamiento cierra pronto. Después sube $8.000.
        </p>
      </div>

      <div className="max-w-2xl mx-auto space-y-4" data-id="element-306">
        <div className="w-full text-left rounded-2xl md:rounded-3xl p-6 md:p-8 border-2 border-brand-pink bg-white shadow-[0_0_30px_rgba(219,39,119,0.15)] relative overflow-hidden" data-id="element-307">
          <div className="absolute top-0 right-0 bg-brand-gold text-brand-dark text-xs md:text-sm font-bold px-4 py-1.5 rounded-bl-xl" data-id="element-308">
            MÁS ELEGIDO
          </div>

          <div className="flex items-start gap-4" data-id="element-309">
            <div className="flex-1 min-w-0" data-id="element-310">
              <div className="flex items-center gap-1.5 mb-2 text-brand-goldDark" data-id="element-311">
                <Trophy className="w-4 h-4 fill-brand-goldDark" data-id="element-312" />
                <Star className="w-3.5 h-3.5 fill-brand-goldDark" data-id="element-313" />
                <span className="text-[10px] md:text-xs font-bold tracking-wider uppercase" data-id="element-314">
                  Acceso Completo
                </span>
              </div>

              <div className="flex flex-col md:flex-row md:items-end justify-between gap-4" data-id="element-315">
                <div className="min-w-0" data-id="element-316">
                  <h3 className="font-serif font-bold text-xl md:text-2xl text-brand-pinkDark leading-tight mb-2" data-id="element-317">
                    🌿 SANTUARIO DIGITAL: MAMÁ SIGUE AQUÍ
                  </h3>
                  <p className="text-sm text-brand-text/70" data-id="element-318">
                    1 Tomo Principal + 3 Bonus
                  </p>
                  <p className="text-xs text-brand-pink font-medium mt-1" data-id="element-319">
                    Ideal para: atravesar el duelo con contención espiritual,
                    herramientas concretas y paz interior desde hoy
                  </p>
                </div>

                <div className="text-left md:text-right shrink-0" data-id="element-320">
                  <p className="text-sm text-brand-text/40 line-through leading-none mb-1" data-id="element-321">
                    $60.000 ARS
                  </p>
                  <p className="font-serif font-bold text-3xl md:text-4xl leading-tight text-brand-pink" data-id="element-322">
                    $19.990 ARS
                  </p>
                </div>
              </div>
            </div>
          </div>

          <motion.a href="https://santuario-digital-mama-sigue-aqui.impultienda.ar/checkout/front" animate={{
          scale: [1, 1.025, 1],
          y: [0, -2, 0]
        }} transition={{
          duration: 2.4,
          ease: 'easeInOut',
          repeat: Infinity
        }} whileHover={{
          scale: 1.04,
          y: -3,
          transition: {
            duration: 0.25
          }
        }} whileTap={{
          scale: 0.98
        }} className="mt-8 w-full inline-flex items-center justify-center px-6 py-4 md:py-5 text-sm md:text-lg font-bold text-white pink-gradient-bg rounded-full animate-glow-pulse relative overflow-hidden cta-shimmer shadow-[0_0_20px_rgba(219,39,119,0.4)]" data-id="element-323">
            <span className="relative z-10" data-id="element-324">🌿 → LO QUIERO — $19.990</span>
          </motion.a>

          <p className="text-center text-xs md:text-sm text-brand-text/60 pt-4" data-id="element-325">
            🛡️ Garantía 7 días · 📥 Descarga inmediata · 🔒 Pago seguro · 💳
            Mercado Pago
          </p>
        </div>
      </div>
    </Section>;
};